import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { ProposedPagePublicationInfoText } from './partials/ProposedPagePublicationInfoText';
import { SonForm } from '../../_lib/Form2';
import { PageManagementActions } from '../../_lib/components/PageManagementActions';
import { PagePublicationInfo } from '../../_lib/components/PagePublicationInfo/PagePublicationInfo';
import { PagePublicationInfoButtons } from '../../_lib/components/PagePublicationInfo/partials/PagePublicationInfoButtons';

type ProposedPagePublicationInfoProps = {
  views: {
    default: { embedded: { proposed: boolean } };
    publishProposal: { embedded: { form: SonForm<any> } };
    rejectProposal: { embedded: { form: SonForm<any> } };
  };
};

function ProposedPagePublicationInfo(props: ProposedPagePublicationInfoProps) {
  const { t } = useSonTranslation('ProposedPagePublicationInfo');
  const proposedPublication = props.views;

  return (
    <PagePublicationInfo headline={t('invisibleHeadline')}>
      <ProposedPagePublicationInfoText hasNoPublicationPrivileges={proposedPublication?.default?.embedded?.proposed} />
      <PagePublicationInfoButtons>
        <PageManagementActions {...props.views} />
      </PagePublicationInfoButtons>
    </PagePublicationInfo>
  );
}

export const ProposedPagePublicationInfoBlock = asFetchableBlock(
  ProposedPagePublicationInfo,
  BlockType.proposedpagepublicationinfo
);
export type ProposedPagePublicationInfoBlock = ComponentProps<typeof ProposedPagePublicationInfoBlock>;
